module.exports = __webpack_public_path__ + "media/images/home/cover-desktop@3x-9b7deea2f7c84d182a7084327ad6af64.jpg";